import SlDropdown from '@shoelace-style/shoelace/components/dropdown/dropdown.component';
import SlIcon from '@shoelace-style/shoelace/components/icon/icon.component';
import {SlMenuItem, SlSelectEvent} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../../../../library/clxProductNet/assets/js/modules/common/assert';

export default class PriceSwitchController {
    private readonly priceDropdowns: NodeListOf<SlDropdown>;
    private readonly chevronIcon: SlIcon | null;

    constructor() {
        this.priceDropdowns = document.querySelectorAll<SlDropdown>(
            '.header_right .price-select sl-dropdown, ' + '.nav_container.sidebar-navigation .price-select sl-dropdown',
        );

        this.chevronIcon = document.querySelector<SlIcon>('sl-icon#dropDownChevron');

        this.init();
    }

    private handleDropDownSelectChange = async (event: SlSelectEvent) => {
        const url = event.detail.item.getAttribute('href');
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    private handleDropDownShow = () => {
        notNull(this.chevronIcon).setAttribute('name', 'chevron-up');
        const menuItems = document.querySelectorAll<SlMenuItem>('.price-select sl-menu-item');
        menuItems.forEach((menuItem) => {
            if (menuItem.classList.contains('.hide')) {
                menuItem.setAttribute('aria-hidden', 'true');
            }
        });
    };

    private handleDropDownHide = () => {
        notNull(this.chevronIcon).setAttribute('name', 'chevron-down');
        const menuItems = document.querySelectorAll<SlMenuItem>('.price-select sl-menu-item');
        menuItems.forEach((menuItem) => {
            if (!menuItem.classList.contains('.hide')) {
                menuItem.removeAttribute('aria-hidden');
            }
        });
    };

    private init() {
        if (this.priceDropdowns.length === 0) {
            return;
        }

        this.priceDropdowns.forEach((dropdown) => {
            dropdown.style.setProperty('--dropdown-width', dropdown.offsetWidth + 'px');

            dropdown.addEventListener('sl-select', this.handleDropDownSelectChange);
            dropdown.addEventListener('sl-show', this.handleDropDownShow);
            dropdown.addEventListener('sl-hide', this.handleDropDownHide);
        });
    }
}
